import { TypePolicies } from "@apollo/client"

export const typePoliciesCompensationInsightsFields: TypePolicies = {
  CompensationInsights: { merge: true },
}
